import React, {useEffect, useState} from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {getImageUrl} from "../../../context/ApplicationContextProvider";

/*
    props
    title : string = 체크박스 옆의 보여줄 타이틀
    on_checked : func(return void) = 부모 컴포넌트의 info(ref) 값 변경
    current_value : bool = 부모 컴포넌트의 info(ref)의 현재 값
 */
const CustomCheckbox = (props) => {
    // state
    const [is_checked, setIsChecked] = useState(false);

    // css style
    const {view} = useComponentStyle(is_checked);

    useEffect(() => {
        if (props.current_value) {
            setIsChecked(true);
        }
    }, [props.current_value]);

    const onChecked = () => {
        setIsChecked(!is_checked);
        props.on_checked(!is_checked);
    };

    return (
        <view.CheckBoxWrapper>
            <view.CheckBoxIcon onClick={onChecked} />
            <view.CheckBoxTitle onClick={onChecked}>{props.title}</view.CheckBoxTitle>
        </view.CheckBoxWrapper>
    );
};

export default CustomCheckbox;

export const useComponentStyle = (is_checked) => {
    const theme = useTheme();
    return {
        view: {
            CheckBoxWrapper: styled.div({
                marginTop: "2.5em",
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "1.5em",
                boxSizing: "border-box",
                fontSize: theme.font_size.f16,
                color: theme.colors.dg1,
            }),
            CheckBoxIcon: styled.div({
                cursor: "pointer",
                width: "1.6em",
                height: "100%",
                background: `url(${
                    !is_checked
                        ? getImageUrl("image/common/ic_check_default_x3.png")
                        : getImageUrl("image/common/ic_check_active_x3.png")
                }) center center/contain no-repeat`,
            }),
            CheckBoxTitle: styled.span({
                marginLeft: ".5em",
                cursor: "pointer",
            }),
        },
    };
};
